import React, { useState } from 'react';
import { Button, Typography, Modal, Box, TextField, IconButton } from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';
//import emailjs from 'emailjs-com';
import ReCAPTCHA from 'react-google-recaptcha';

import {sendEmail} from '../controller.tsx';

const NewsletterModal = ({ isOpen , setIsOpen }) => {
    const RECAPTCHA_SITE_KEY = '6LfCai8rAAAAAAmbuUbyai5mssEpJBqSPCQot0rr'; // From Google

    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [company, setCompany] = useState('');
    const [email, setEmail] = useState('')
    const [aboutYou, setAboutYou] = useState('');

    const [captchaToken, setCaptchaToken] = useState(null);

    const handleCaptchaChange = (token) => {
      setCaptchaToken(token);
    };

    const handleClose = () => setIsOpen(false);

    const handleSendEmail = async(e) => {
        if (!captchaToken) {
            alert("Please complete the CAPTCHA.");
            return;
        }

        if(firstName==='' || lastName==='' || email==='' || aboutYou===''){
            return;
        }
        if(!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email)){
            return;
        }
        const message = `Company: ${company}\nemail: ${email}\n${aboutYou}`
        const params = {
            to: email,
            subject: `New email from ${firstName} ${lastName}`,
            text: message,
            html: `<p><strong>Message from:</strong> ${firstName}</p><p><strong>Email:</strong> ${email}</p><p><strong>Message:</strong><br>${message}</p>`,
            captchaToken: captchaToken
        }
        await sendEmail(params)
        setFirstName('');
        setLastName('');
        setEmail('');
        setAboutYou('');
        setCompany('');
        handleClose();
    }
    return(
        <Modal open={isOpen} onClose={handleClose} sx={{overflow:'scroll',}}>
            <Box sx={{
                position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)',
                bgcolor: 'background.paper', p: 3, borderRadius: 2, boxShadow: 24, width: 400,
                maxWidth: '90%', '@media (max-width: 600px)': {
                  width: '90%',
                  padding: 2,
                }
            }}>
                <IconButton sx={{ position: 'absolute', right: 8, top: 8 }} onClick={handleClose}><CloseIcon /></IconButton>
                <Typography id="resume" padding="5px 0px" variant="h4">Register to post events</Typography>
                <Box>
                    <TextField variant="filled" fullWidth required id="fName" label="First Name" margin="dense"
                      value={firstName}
                      onChange={(event)=>setFirstName(event.target.value)}
                    />
                    <TextField variant="filled" fullWidth required id="lName" label="Last Name" margin="dense"
                        value={lastName}
                        onChange={(event)=>setLastName(event.target.value)}
                    />
                    <TextField variant="filled" fullWidth required id="companyName" label="Company (optional)" margin="dense"
                        value={company}
                        onChange={(event)=>setCompany(event.target.value)}
                    />
                    <TextField variant="filled" fullWidth required id="email" label="Email" margin="dense"
                      value={email}
                      onChange={(event)=>setEmail(event.target.value)}
                    />
                    <TextField variant="filled" fullWidth required id="about-you" label="More about you" margin="dense" multiline rows={4}
                      value={aboutYou}
                      onChange={(event)=>setAboutYou(event.target.value)}
                    />
                    <ReCAPTCHA
                          sitekey={RECAPTCHA_SITE_KEY}
                          onChange={handleCaptchaChange}
                          style={{ margin: '10px 0' }}
                    />
                    <Button variant="contained" sx={{ mb: 1, backgroundColor:'#263238' }}  disabled={!captchaToken} onClick={handleSendEmail}>Submit</Button>
                </Box>
            </Box>
        </Modal>
    )
}

export default NewsletterModal;